// Historias clínicas POR MÉDICO (30/9/2026). Cada médico escribe la suya; la
// que ya tenía la ficha sale como «Historia anterior (sin autor)» y se sigue
// guardando con el PUT de la ficha (campo `historia_general`). Las reglas de
// quién puede qué las pone el servidor (`routers/historias_router.py`) y
// llegan en cada historia (`puede_editar`) y en la lista (`puede_crear`).
import { api } from './api';

/** Las historias del paciente, la más reciente primero, y si quien mira
 *  puede empezar la suya. Acepta también una lista a secas. */
export async function listHistorias(patientId) {
  const res = await api.get('/api/historias', { params: { patient_id: patientId } });
  const data = res?.data;
  if (Array.isArray(data)) return { historias: data, puede_crear: false };
  return {
    historias: Array.isArray(data?.historias) ? data.historias : [],
    puede_crear: data?.puede_crear === true,
  };
}

/** «Nueva historia»: a nombre de quien la crea (lo pone el servidor). */
export async function crearHistoria(patientId, texto = '') {
  const res = await api.post('/api/historias', { patient_id: patientId, texto });
  return res?.data;
}

/** Guarda el texto con el sello de la versión que se tenía delante: si otra
 *  persona la cambió entre medias, el servidor contesta 409 y no escribe. */
export async function guardarHistoria(historiaId, texto, vistoUpdatedAt) {
  const cuerpo = vistoUpdatedAt ? { texto, visto_updated_at: vistoUpdatedAt } : { texto };
  const res = await api.put(`/api/historias/${historiaId}`, cuerpo);
  return res?.data;
}

/** «Dra. X — 12/9/2026» o la de la historia anterior, como la da el servidor. */
export function etiquetaHistoria(h) {
  if (!h) return '';
  if (h.etiqueta) return h.etiqueta;
  if (h.anterior || h.sin_autor) return 'Historia anterior (sin autor)';
  return h.autor_nombre || 'Historia';
}

/** La que se abre por defecto: la de quien mira si tiene alguna (la más
 *  recientemente escrita); si no, la más reciente de todas. */
export function historiaPorDefecto(historias) {
  const lista = Array.isArray(historias) ? historias : [];
  const masReciente = (xs) => [...xs].sort(
    (a, b) => String(b.updated_at || b.created_at || '').localeCompare(String(a.updated_at || a.created_at || '')),
  )[0] || null;
  return masReciente(lista.filter((h) => h.es_mia)) || masReciente(lista);
}
